import axios from "axios";

export const getProfile = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Auth/profile`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
